(() => {
  if (customElements.get('excentric-header-logo')) return;
  customElements.define('excentric-header-logo', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.initialized = true;
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      this.onPlaying = () => {
        if (!this.canPlay()) { this.stop(); return; }
        this.video.hidden = false;
      };
      this.onError = () => this.stop();
      this.onState = () => { if (this.canPlay()) this.start(); else this.stop(); };
      this.video.muted = true;
      this.video.loop = true;
      this.video.addEventListener('playing', this.onPlaying);
      this.video.addEventListener('error', this.onError);
      this.preference.addEventListener('change', this.onState);
      document.addEventListener('visibilitychange', this.onState);
      this.onState();
    }
    canPlay() {
      return this.isConnected && !this.preference.matches && !document.hidden && !!this.dataset.videoUrl;
    }
    start() {
      this.stop();
      if (!this.canPlay()) return;
      if (!this.video.getAttribute('src')) this.video.src = this.dataset.videoUrl;
      this.video.currentTime = 0;
      this.video.play().catch(() => this.stop());
    }
    stop() {
      this.video.pause();
      this.video.hidden = true;
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      this.stop();
      this.video.removeEventListener('playing', this.onPlaying);
      this.video.removeEventListener('error', this.onError);
      this.preference.removeEventListener('change', this.onState);
      document.removeEventListener('visibilitychange', this.onState);
      this.initialized = false;
    }
  });
})();
